/* eslint-disable react-hooks/rules-of-hooks */
import { FilteredModifierValues, GroupPrices, Modifier, Variant, VariantModifier } from '@/types/menus.types';
import { StoreAndGroupType } from '@/context/context.types';
import _ from 'lodash';

const normalizeMenuData = (filteredModifiers: Modifier[]): Modifier[] => {
  const allModifiers = filteredModifiers;

  return allModifiers;
};

const normalizeMenuModifiersData = (filteredProducts: Modifier[]): Modifier[] => {
  const allProducts = filteredProducts;

  return allProducts;
};

export const getDinamicHeaders = (storesAndGroups: StoreAndGroupType) => {
  let allHeaders = storesAndGroups.storeGroups?.flatMap((group) => group.storeGroup) || [];
  if (allHeaders.length === 0) {
    allHeaders = storesAndGroups.stores?.flatMap((group) => group.storeGroup || []) || [];
  }
  const uniq = _.uniqBy(allHeaders, (header) => header);
  const sorted = _.sortBy(uniq, (header) => header);

  return sorted;
};

const filterModifiers = (modifier: Modifier, filteredValues: FilteredModifierValues): boolean => {
  const { modifierName = '', option1 = '', option2 = '', subCategory = '' } = filteredValues;
  const description = modifier.modifierDescription.toLowerCase();
  const name = modifier.modifierName.toLowerCase();

  let optionOk = true;
  if (option1 && option2) {
    optionOk = description.includes(option1.toLowerCase()) && description.includes(option2.toLowerCase());
  } else if (option1) {
    optionOk = description.includes(option1.toLowerCase());
  } else {
    optionOk = description.includes(option2.toLowerCase());
  }
  const nameOK = name.includes(modifierName.toLowerCase()) && modifier.storeGroups.length > 0;

  return optionOk && nameOK;
};
//
// const filterModifiers = (product: Modifier, filteredValues: FilteredValues): boolean => {
//   const { modifierName = '', option1 = '', option2 = '', subCategory = '' } = filteredValues;
//   const description = product.modifierDescription.toLowerCase();
//   const name = product.modifierName.toLowerCase();
//
//   let optionOk = true;
//   if (option1 && option2) {
//     optionOk = description.includes(option1.toLowerCase()) && description.includes(option2.toLowerCase());
//   } else if (option1) {
//     optionOk = description.includes(option1.toLowerCase());
//   } else {
//     optionOk = description.includes(option2.toLowerCase());
//   }
//   const nameOK = name.includes(modifierName.toLowerCase()) && product.storeGroups.length > 0;
//
//   return optionOk && nameOK;
// };
//
export const getStoreFilteredProducts = (modifiers: Modifier[], filteredValues: FilteredModifierValues): Modifier[] => {
  const { price = '' } = filteredValues;
  let filteredModifiers: Modifier[] = modifiers;
  if (price) {
    filteredModifiers = modifiers
      .map((modifier) => ({
        ...modifier,
        storeGroups: Array.isArray(modifier.storeGroups)
          ? modifier.storeGroups.filter((storeGroup) => {
              let priceValue: number | null = null;
              if (price.startsWith('$')) {
                priceValue = Number(price.replace('$', ''));
              }
              if (priceValue !== null) {
                const { chosenPriceRange } = storeGroup;

                if (typeof chosenPriceRange === 'number') {
                  return chosenPriceRange === priceValue;
                }

                if (typeof chosenPriceRange === 'string') {
                  const [min, max] = chosenPriceRange.split('-').map(Number);
                  if (max === undefined) {
                    const chosenPriceValue = Number(chosenPriceRange);
                    if (priceValue === 0) {
                      return chosenPriceValue === 0;
                    }
                    return chosenPriceValue === priceValue;
                  }
                  return priceValue >= min && priceValue <= max;
                }
              }
              return true;
            })
          : [],
      }))
      .filter((product) => filterModifiers(product, filteredValues));
  } else {
    filteredModifiers = modifiers.filter((product) => filterModifiers(product, filteredValues));
  }

  // Ensure storeGroups is always an array for all modifiers
  filteredModifiers = filteredModifiers.map((modifier) => ({
    ...modifier,
    storeGroups: Array.isArray(modifier.storeGroups) ? modifier.storeGroups : [],
  }));

  return normalizeMenuData(filteredModifiers);
};
//
// export const getStoreFilteredModifiers = (prods: Modifier[], filteredValues: FilteredValues): Modifier[] => {
//   const { price = '' } = filteredValues;
//   let filteredProducts: Modifier[] = prods;
//   if (price) {
//     filteredProducts = prods
//       .map((product) => ({
//         ...product,
//         storeGroups: product.storeGroups.filter((storeGroup) => {
//           let priceValue: number | null = null;
//           if (price.startsWith('$')) {
//             priceValue = Number(price.replace('$', ''));
//           }
//           if (priceValue !== null) {
//             const { chosenPriceRange } = storeGroup;
//
//             if (typeof chosenPriceRange === 'number') {
//               return chosenPriceRange === priceValue;
//             }
//
//             if (typeof chosenPriceRange === 'string') {
//               const [min, max] = chosenPriceRange.split('-').map(Number);
//               if (max === undefined) {
//                 const chosenPriceValue = Number(chosenPriceRange);
//                 return chosenPriceValue === priceValue;
//               }
//               return priceValue >= min && priceValue <= max;
//             }
//           }
//           return true;
//         }),
//       }))
//       .filter((product) => filterModifiers(product, filteredValues));
//   } else {
//     filteredProducts = prods.filter((product) => filterModifiers(product, filteredValues));
//   }
//
//   return normalizeMenuModifiersData(filteredProducts);
// };
//
export function getStores(storesAndGroups: StoreAndGroupType) {
  if (storesAndGroups.origin === 'tab-store') {
    return storesAndGroups.stores?.map((store) => store.storeNo) || [];
  }
  return storesAndGroups.storeGroups?.flatMap((group) => group.stores) || [];
}

export function getStoreGroups(storesAndGroups: StoreAndGroupType) {
  if (storesAndGroups.origin === 'tab-store') {
    return [];
  }
  return storesAndGroups.storeGroups?.filter((group) => group.stores.length === group.storeCount) || [];
}

export function isPriceInvalid(inputPrice: string, lowestValidPrice: string, highestValidPrice: string) {
  const price = Number(inputPrice.replace('$', ''));
  const lowerPrice = Number(lowestValidPrice);
  const highPrice = Number(highestValidPrice);

  const invalid = price < lowerPrice || price > highPrice;

  return invalid;
}

export function combineStoreGroupPrices(modifiers: Modifier[], storesAndGroups: StoreAndGroupType) {
  const storeGroupList = modifiers?.flatMap((modifier) => modifier.storeGroups);

  const count = storesAndGroups?.countByStoreGroup;

  const result = storeGroupList.reduce((acc: GroupPrices[], curr) => {
    const existingStoreGroup = acc.find((group) => group.storeGroupName === curr?.storeGroupName);

    //values used when FZ user selects stores via StoreGroup tab in menu page
    const totalStoreCount = count?.find((obj) => obj.storeGroup === curr?.storeGroupName);
    const selectStoreGroupCount = storesAndGroups.storeGroups?.filter(
      (group) => group.storeGroup === curr?.storeGroupName,
    );

    //values used when FZ user selects stores via All Stores tab in menu page
    const selectAllStoreCount = storesAndGroups.stores?.filter((group) => group.storeGroup === curr?.storeGroupName);
    const selectedAllStores = selectAllStoreCount?.filter((store) => store.storeGroup === curr?.storeGroupName);
    const selectedAllStoreCount = selectedAllStores?.length;

    if (existingStoreGroup) {
      existingStoreGroup.prices.push(curr?.chosenPriceRange ?? '');
    } else if (selectStoreGroupCount) {
      acc.push({
        storeGroupName: curr?.storeGroupName,
        prices: [curr?.chosenPriceRange ?? ''],
        selectedStoreCount: selectStoreGroupCount[0]?.stores?.length,
        totalStoreCount: selectStoreGroupCount[0]?.storeCount,
        stores: curr.stores,
      });
    } else if (selectAllStoreCount) {
      acc.push({
        storeGroupName: curr?.storeGroupName,
        prices: [curr?.chosenPriceRange ?? ''],
        selectedStoreCount: selectedAllStoreCount || 0,
        totalStoreCount: totalStoreCount?.count || 0,
        stores: curr.stores,
      });
    }
    return acc;
  }, []);
  return result;
}
export function splitArray(toSplit: any[] = []) {
  const middleIndex = Math.ceil(toSplit.length / 2);
  const firstHalf = toSplit.slice(0, middleIndex);
  const secondHalf = toSplit.slice(middleIndex);
  return [firstHalf, secondHalf];
}

export const checkIfHasVariants = (variants: VariantModifier[]) => {
  if (!Array.isArray(variants)) return false;
  return variants.some((variant) => Array.isArray(variant.excludedStores) && variant.excludedStores.length > 0);
};

export const getUniqStores = (variants: VariantModifier[]) => {
  if (!Array.isArray(variants)) return [];
  const variantStores = variants.flatMap((sp) => (Array.isArray(sp.variantStores) ? sp.variantStores : []));
  const uniqueStores = _.uniqBy(variantStores, (store) => store);
  return uniqueStores || [];
};
